import { Badge } from '@/components/ui/badge';
import { CoachSessionRemarkV2, CoachSessionRemarkV2LabelMap } from '@airreading/common/data';

interface TeacherDisplayTagBadgeV2Props {
  tags: CoachSessionRemarkV2[] | null | undefined;
}

export function TeacherDisplayTagBadgeV2({ tags }: TeacherDisplayTagBadgeV2Props) {
  if (!tags || tags.length === 0) return <>—</>;

  return (
    <div className="flex flex-col gap-1 items-center">
      {tags.map((tag) => (
        <Badge key={tag} variant="outline" className="text-center">
          {CoachSessionRemarkV2LabelMap[tag]}
        </Badge>
      ))}
    </div>
  );
}
